import "./../../blocks/blocks";
import "./internal.js";
import BetterMenu from "./lib/better-menu/better-menu";
import BetterModal from "./lib/better-menu/better-modal";
import "./lib/header-handler";

document.addEventListener("DOMContentLoaded", function () {
	console.log("app.js loaded");
	document.querySelector("body").setAttribute("data-s-loaded", "");
	new BetterMenu();
	new BetterModal();
});

// check if gform object exists
if (typeof gform !== "undefined") {

	gform.addFilter( 'gform_datepicker_options_pre_init', function( optionsObj, formId, fieldId ) {
		// Apply to field 2 only
		if ( fieldId == 2 ) {
			// minDate 5 days from now
			optionsObj.minDate = new Date( new Date().getTime() + 5 * 24 * 60 * 60 * 1000 );
		}
		return optionsObj;
	});
}
